import React, { useContext, useEffect, useState } from "react";

import { Row, Col } from "../Grid";
import { Container, Line, Tag, Tags, TagText, TagTitle, Title } from "./styles";
import Icon from "../Icon";
import FitinsurAPI from '../../utils/src/fitinsur-api'

const EndorsementTagList = ({tags = [], removeTag, showRemoveIcon, attachments, idOperation, requestExpireDocument, contextApp}) => {

    if (!Array.isArray(tags)) return null;

    const endorsementContractTags = tags.filter((tag) => tag.documentType.idAnswerOption === '7524');
    const additionalEndorsement = tags.filter((tag) => tag.documentType.idAnswerOption === '7525');
    const otherDocuments = tags.filter((tag) => tag.documentType.idAnswerOption !== '7525' && tag.documentType.idAnswerOption !== '7524');

    const firstTitle = () => {
      if (endorsementContractTags.length) {
        return "Endorsement Contract:";
      }
      if (additionalEndorsement.length) {
        return "Additional Endorsement Documents:";
      }
      return "Other Documents:";
    };

    if(!tags.length) return null;
    
    const expireDocuments = (idOperation, idDocument) => {
      const fitinsur = new FitinsurAPI();
      fitinsur.setAuthToken(contextApp.token);
      fitinsur.requestExpireDocument(Number(idOperation), idDocument)
        .then((data) => console.log(data));
    };

    return (
        <Container>
                <Tags>
                    <Col><Title>{firstTitle()}</Title></Col>
                    <Col/>
                    <Col><Title>Relavant To</Title></Col>
                    <Col><Title>Which Insurer</Title></Col>
                    {
                        showRemoveIcon && <Col/>
                    }
                </Tags>
            {
                endorsementContractTags.map((tag, index) => {
                    if (tag.deleteAttachment) return <></>

                    return (
                      <Tags key={index}>
                        <Col />
                        <Col>
                          <Tag>
                            <TagTitle href={tag.fileUrl} target="_blank">
                              {tag.fileName}
                            </TagTitle>
                          </Tag>
                        </Col>
                        <Col>
                          <TagText>{tag.relevantTo?.dsRelevantTo}</TagText>
                        </Col>
                        <Col>
                          <TagText>{tag.whichInsurer?.dsWhichInsurer}</TagText>
                        </Col>
                        {showRemoveIcon && (
                          <Col>
                            <Icon
                              name="trash"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                removeTag(tag.documentId)
                              }}
                            ></Icon>
                          </Col>
                        )}
                      </Tags>
                    );
                })
            }
            {(endorsementContractTags.length && additionalEndorsement.length) ? 
                <>
                <Line/> 
                    <Tags><Col><Title>Additional Endorsement Documents:</Title></Col></Tags>

                </> 
                : ''
            }

            {
                additionalEndorsement.map((tag, index) =>  {
                    if (tag.deleteAttachment) return <></>

                    return (
                      <Tags key={index}>
                        <Col />
                        <Col>
                          <Tag>
                            <TagTitle href={tag.fileUrl} target="_blank">
                              {tag.fileName}
                            </TagTitle>
                          </Tag>
                        </Col>
                        <Col>
                          <TagText>{tag.relevantTo?.dsRelevantTo}</TagText>
                        </Col>
                        <Col>
                          <TagText>{tag.whichInsurer?.dsWhichInsurer}</TagText>
                        </Col>
                        {showRemoveIcon && (
                          <Col>
                            <Icon
                              name="trash"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                removeTag(tag.documentId);
                                expireDocuments(idOperation, tag.documentId);
                              }}
                            ></Icon>
                          </Col>
                        )}
                      </Tags>
                    );
                })
            }
            {(endorsementContractTags.length && additionalEndorsement.length && otherDocuments.length) ? 
                <>
            <Line/> 
                    <Tags><Col><Title>Other Documents:</Title></Col></Tags>

                </> 
                : ''
            }

            {
                otherDocuments.map((tag, index) =>  {
                    if (tag.deleteAttachment) return <></>

                    return (
                        <Tags key={index}>
                            <Col/>
                            <Col><Tag><TagTitle>{tag.fileName}</TagTitle></Tag></Col>
                            <Col><TagText>{tag.relevantTo?.dsRelevantTo}</TagText></Col>
                            <Col><TagText>{tag.whichInsurer?.dsWhichInsurer}</TagText></Col>
                            {
                                showRemoveIcon && (
                                    <Col>                        
                                        <Icon name="trash" style={{ cursor: 'pointer' }} onClick={() => removeTag(tag.documentId)}></Icon>
                                    </Col>
                                )
                            }
                        </Tags>
                    )
                })
            }

            {
                (attachments && attachments.length) ? (

                    attachments.map((tag, index) =>  {
                    
                       return (
                           <>  
                                <Line/>
                               <Tags><Col><Title>Attachments:</Title></Col></Tags>
                               <Tags key={index}>
                                   <Col>{tag.dsTypeDocument && <Title>{tag.dsTypeDocument}</Title>}</Col>
                                   <Col><Tag><TagTitle href={tag.urlLink} target="_blank">{tag.nameFile}</TagTitle></Tag></Col>
                                   <Col/>
                                   <Col/>
                           </Tags>
                           </>
                       )
                    })
                    ) : <></>
            }

            <Line/>
        </Container>
    )

}

export default EndorsementTagList;